import styled from "styled-components";

export const RewardImageBox = styled.div<{ completed: boolean }>`
	position: absolute;
	top: -4em;
	right: -3em;
	width: 6em;
	display: flex;
	align-items: center;
	justify-content: center;
	//filter: ${({ completed }) => (completed ? "grayscale(100%)" : "none")};
	//opacity: ${({ completed }) => (completed ? 0.6 : 1)};

	@media (orientation: portrait) and (max-width: 899px) {
		top: -2.6em;
		right: auto;
		left: 9em;
	}
`;

export const RewardImg = styled.img`
	width: auto;
	height: 6em;

	&.completed {
		filter: grayscale(100%);
		opacity: 0.6;
	}
`;

export const RewardText = styled.div`
	position: absolute;
	right: -0.2em;
	bottom: -0.1em;
	color: #fff;
	paint-order: stroke fill;
	width: 1.1em;
	filter: drop-shadow(0.0108em 0.0308em 0 #000);
	-webkit-text-stroke-width: 0.2em;
	-webkit-text-stroke-color: #000;
	font-family: "Baloo";
	font-size: 2.7em;
	font-style: normal;
	font-weight: 400;
	line-height: 91.176%;
`;

export const Check = styled.div`
	position: absolute;
	right: -0.2em;
	bottom: -0.1em;
	width: 1.3271em;
	height: 1.3271em;

	svg,
	img {
		width: 1.3271em;
		height: 1.3271em;
	}

	@media (orientation: portrait) and (max-width: 899px) {
		right: 0.1em;
	}
`;
